<template>
  <!-- 法律条例详情页 -->
  <div class="tiaolidetial">
    <div class="cont between">
      <div class="left">
        <ifilawtj />
        <tldetailcont class="mt30" />
      </div>
      <div class="righ">
        <ifisea />
        <ifirmfg class="mt30" />
        <ifionlinezx class="ifionlinezx mt30" />
      </div>
    </div>
  </div>
</template>

<script>
import ifilawtj from "views/tiaoliify/components/ifilawtj";
import ifisea from "views/tiaoliify/components/ifisea";
import ifirmfg from "views/tiaoliify/components/ifirmfg";
import ifionlinezx from "views/tiaoliifyul/components/tiaolionline";
import tldetailcont from "./child/tldetailcont";
export default {
  name: "tiaolidetial",
  components: {
    ifilawtj,
    ifisea,
    ifirmfg,
    ifionlinezx,
    tldetailcont,
  },
};
</script>

<style lang="scss" scoped>
.tiaolidetial {
  width: 100%;

  background: #f8f8f8;
  .cont {
    width: 1200px;
    padding: 50px 0;
    margin: 0 auto;
    align-items: flex-start;
    .left {
      width: 856px;
    }
    .righ {
      width: 314px;
      .ifionlinezx {
        width: 314px;
        height: 318px;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
      }
    }
  }
}
</style>